/**
 * Used when reading enum values from the backend.
 * Equivalent to MyEnum[raw] but fallbacks to the raw value if we don't know the enum.
 *
 * Avoids erasing an unknown enum value for easier debuggability.
 */
export function enumValueOrRaw<T extends Record<string, unknown>>(enumType: T, raw: keyof T): T[keyof T] {
  return (
    enumType[raw] ?? (raw as T[keyof T]) // This part is a lie but it's a safety to avoid converting a proper unknown-to-the-frontend value to `undefined`
  );
}
